//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.type.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.wintermar.inspection.graphql.type.InspectionAnswerType

public object InspectionAnswerType_ResponseAdapter : Adapter<InspectionAnswerType> {
  override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionAnswerType {
    val rawValue = reader.nextString()!!
    return InspectionAnswerType.safeValueOf(rawValue)
  }

  override fun toJson(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    `value`: InspectionAnswerType,
  ) {
    writer.value(value.rawValue)
  }
}
